/* eslint-disable react/display-name */
import * as React from 'react';

const Newsletter = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path d="M4.55,11l1.21,1.44L4.5,13.58Zm.76-1.62,8.06-6.15L9,13.53ZM2.21,5.9,12.64,2.21l-8.28,6ZM.13,5.9,3.47,9.67V15.2a.5.5,0,0,0,.5.51.53.53,0,0,0,.36-.15l2.28-2.34,2.26,2.61a.51.51,0,0,0,.71.05.52.52,0,0,0,.14-.19L16,.7A.5.5,0,0,0,15.69,0a.5.5,0,0,0-.36,0L.34,5.09A.5.5,0,0,0,0,5.73.42.42,0,0,0,.13,5.9Z" />
  </svg>
);

export default Newsletter;
